import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ReturnsState, SalesTax } from '@avalara/types/reducer-states';

const initialState: ReturnsState = {
  salestax: null,
};

const store = createSlice({
  name: 'returns',
  initialState,
  reducers: {
    setReturnsSalesTax: (state, action: PayloadAction<SalesTax>) => {
      state.salestax = action.payload;
    },
  },
});

export const { setReturnsSalesTax } = store.actions;

export default store;
